import { render, staticRenderFns } from "./ComplexFieldForm.vue?vue&type=template&id=53bdf5bf&"
import script from "./ComplexFieldForm.vue?vue&type=script&lang=js&"
export * from "./ComplexFieldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53bdf5bf')) {
      api.createRecord('53bdf5bf', component.options)
    } else {
      api.reload('53bdf5bf', component.options)
    }
    module.hot.accept("./ComplexFieldForm.vue?vue&type=template&id=53bdf5bf&", function () {
      api.rerender('53bdf5bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/components/SystemFieldForm/components/ComplexFieldForm.vue"
export default component.exports